import { useNavigate } from "@tanstack/react-router";
import { FileText } from "lucide-react";
import { AdminBreadcrumb } from "@/components/admin/AdminBreadcrumb";
import { AdminPageShell } from "@/components/admin/AdminPageShell";
import { PedidoReportWorkspace } from "@/components/reports/PedidoReportWorkspace";

export function RelatoriosPage() {
  const navigate = useNavigate();

  return (
    <AdminPageShell
      breadcrumb={
        <AdminBreadcrumb
          items={[
            { label: "Mais", onClick: () => navigate({ to: "/mais" }) },
            { label: "Relatórios" },
          ]}
        />
      }
      icon={FileText}
      title="PEDIDOS"
      size="wide"
      showIcon={false}
    >
      <div className="pedido-report-page">
        <PedidoReportWorkspace />
      </div>
    </AdminPageShell>
  );
}
